import type { ActivityModule } from '../../core/activity';
import { mountNumbersOddEven } from './ui';
import levelsData from './levels.json';
import './style.css';

export const numbersOddEven: ActivityModule = {
  id: 'numbers-odd-even',
  title: 'Pares e ímpares',
  description: 'Classifique cada número em par ou ímpar. Toque num número e depois na caixa certa.',
  ageMin: 6,
  ageMax: 10,
  difficulty: 2,
  iconPath: 'assets/gcompris-AGPL/numbers-odd-even/icon.svg',
  category: 'numeracao',
  totalLevels: levelsData.levels.length,
  mount: mountNumbersOddEven,
};
